import { StyleSheet, View } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  block: {
    marginTop: 20,
  },
});

type BlockProps = {
  children: React.ReactNode;
};

export const Block = ({ children }: BlockProps) => {
  return <View style={styles.block}>{children}</View>;
};
